module.exports = __webpack_public_path__ + "static/media/GPG116B_H06_LB.a675f716.jpg";